import React, { Component } from 'react';
import {
  BrowserRouter as Switch
   // ,
   // Redirect
} from 'react-router-dom';
import Route from 'react-router-dom/Route';


//css
import './App.scss'

//components
import Menu from './Components/menu/Menu';
import Footer from './Components/Footer/Footer';
import AdquirirProductos from './Components/Cotizar/AdquirirProductos'

//Pages
import Index from './Pages/Index/Index';
import Productos from './Pages/Productos/Productos';
import QuienesSomos from './Pages/QuienesSomos/QuienesSomos';
import Contactenos from './Pages/Contactenos/Contactenos';

// import Error from './Pages/Error/Error';
import TerminosCondiciones from './Pages/TerminosCondiciones/TerminosCondiciones'
import Politicas from './Pages/Politicas/Politicas'

class App extends Component {
  constructor(props){
    super(props);
    this.state = {
      cotizacion:"false",
      backgroundColor:'App'
    }
  }
  render() {
    return (
      <Switch >
        <div className="app" >
          <Menu/>
          <Route to="/" path="/" exact render={
            ()=>{
              return (<Index />)
            }
          }/>
          <Route path="/Contactenos" exact strict render={
            ()=>{
              return(<Contactenos/>)
            }
          }/>
          <Route path="/Quienes-Somos" exact strict render={
            ()=>{
              return(<QuienesSomos/>)
            }
          }/>
          <Route path="/Productos" exact strict render={
            ()=>{return(<Productos/>)}
          }/>
          <Route path="/Terminos-Condiciones" exact strict render={
            ()=>{return(<TerminosCondiciones/>)}
          } />
          <Route path="/Politicas" exact strict render={
            ()=>{return(<Politicas/>)}
          }/>
          {/*<Route comonent={Errors}/>
          <Redirect to="/Error" path="/Error" exact strict render={
              ()=>{return(<Error/>)}
            }/>*/}
          <AdquirirProductos/>
          <Footer/>
        </div>
      </Switch>
    );
  }
}
export default App;



// WEBPACK FOOTER //
// ./src/App.jsx